export class Theme {
    id: number;
    name: string;

    constructor(theme: any) {
        Object.assign(this, theme);
    }
}
